import { render } from "./Donations.vue?vue&type=template&id=2b34aaf2"
import script from "./Donations.vue?vue&type=script&lang=js"
export * from "./Donations.vue?vue&type=script&lang=js"
script.render = render

export default script